// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { msalInstance, tokenRequest } from '../auth/msal/msalConfig';

// initialize an empty api service that we'll inject endpoints into later as needed
export const api = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_GATEWAY_URL as string,
    prepareHeaders: async (headers) => {
      const account = msalInstance.getAllAccounts();
      if (account.length > 0) {
        const response = await msalInstance.acquireTokenSilent({
          ...tokenRequest,
          account: account[0]
        });

        if (response.accessToken) {
          headers.set('authorization', `Bearer ${response.accessToken}`);
        }
      }

      return headers;
    }
  }),
  endpoints: () => ({})
});
